<template>
  <div class="home">
    <SubTitle subtitle="Welcome" description="Matsuoのポートフォリオサイトへようこそ。" />
  </div>
</template>

<script>
export default {
  name: "Home",
  title: "Home"
};
</script>
